import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive } from 'vue';
export default {
  __name: 'ColorPicker',
  props: {
    colors: {
      type: String,
      required: true
    }
  },
  emits: ['colorPicked'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const colorState = reactive({
      selectedColor: props.colors
    });
    function onColorChange(value) {
      emit('colorPicked', {
        hex: value
      });
    }
    return (_ctx, _cache) => {
      const _component_v_color_picker = _resolveComponent("v-color-picker");
      return _openBlock(), _createBlock(_component_v_color_picker, {
        modelValue: colorState.selectedColor,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => colorState.selectedColor = $event), onColorChange],
        mode: "hex",
        modes: ['hex', 'rgb', 'hsl'],
        "show-swatches": "",
        "swatches-max-height": 120,
        elevation: "0",
        width: "280"
      }, null, 8, ["modelValue"]);
    };
  }
};